export default __webpack_public_path__ + "static/vue-9e57b506c782bf444ad67e0c4cbf90e4.png";